import {observer} from 'mobx-react';
import moment from 'moment';
import {Modal, ModalButtons} from 'shared/components/modals';
import {DatePicker, FormLayout, LabelHelper, ObjectSelect2, QuickTip} from 'shared/components';
import {t, withState} from 'shared/core';
import InterviewInviteModalState from 'main/containers/recruiting/state/InterviewInviteModalState';

const InterviewInviteModal = observer(({uiState, isOpen, onClose}) => {
  const {interviewInvite, scheduleOptions, editing, errors} = uiState;

  const selectedSchedule = interviewInvite.interviewSchedule;

  return (
    <Modal
      isOpen={isOpen}
      onHide={() => onClose()}
      size='sm'
      title={editing ? 'recruiting.hiring_funnel.Edit interview invite' : 'recruiting.hiring_funnel.Send interview schedule invite'}
    >
      <FormLayout>
        {interviewInvite.booked && <QuickTip
          trait='caution'
          paragraphs={[t('recruiting.hiring_funnel.Updating only affects potential rescheduling and does not change the already booked interview.')]}
        />}
        <ObjectSelect2
          label='recruiting.hiring_funnel.Interview schedule'
          placeholder='recruiting.hiring_funnel.Select an interview schedule'
          value={selectedSchedule}
          items={scheduleOptions}
          display='templateName'
          onChange={schedule => uiState.selectInterviewSchedule(schedule)}
          searchable
        />
        {selectedSchedule && <div>
          <LabelHelper label='recruiting.hiring_funnel.Allow booking from' translateLabel/>
          <div className='flex align-items-center gap-1'>
            <div className='flex-grow'>
              <DatePicker
                value={moment(interviewInvite.startDate)}
                onChange={date => interviewInvite.startDate = date}
                errorMessage={errors.startDate}
                options={{startDate: new Date()}}
              />
            </div>
            {'-'}
            <div className='flex-grow'>
              <DatePicker
                value={moment(interviewInvite.endDate)}
                onChange={date => interviewInvite.endDate = date}
                errorMessage={errors.endDate}
                options={{startDate: new Date()}}
              />
            </div>
          </div>
        </div>}
      </FormLayout>
      <ModalButtons
        onSave={() => uiState.saveInterviewInvite()}
        saveCaption={editing ? 'recruiting.hiring_funnel.Save' : 'recruiting.hiring_funnel.Send'}
        saveEnabled={!!selectedSchedule}
        onCancel={() => onClose()}
      />
    </Modal>
  );
});

export default withState(InterviewInviteModal, InterviewInviteModalState);
